import { localeStore } from '@/shared/i18n/locale-store';
import type { Locale } from '@/shared/i18n/locales';

/** 1250 → "12,5" (Spanish) or "12.5" (English): what a money input shows; parseEuros reads both. */
export function centsToInput(cents: number | undefined | null, locale: Locale = localeStore.read()): string {
  if (cents == null) return '';
  const text = (cents / 100).toFixed(2).replace(/\.00$/, '');
  return locale === 'es-ES' ? text.replace('.', ',') : text;
}
